<template>

 <b-row class="">

    <!-- Modalidade pix -->
    <b-col cols="12" class="" >
      <h5 class="font-weight-semibold">ApiKey </h5>
    </b-col>

    <!-- Multa por atrazo -->
   <b-col md="8">
      <b-form-group>
        <label class="" >ApiKey para acesso a api PagWise</label>
        <feather-icon

            icon="AlertCircleIcon"
            size="10"
            class="text-info ml-1"
            badge-classes="badge-info"
          />
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-form-checkbox
              name="checkbox-input"
            />
          </b-input-group-prepend>
          <b-form-input 
           disabled
          :value= "estabelecimento.apiKey"  />
        </b-input-group>
      </b-form-group>
    </b-col>

   
    <!-- Callback -->
    <b-col cols="12" class="" >
      <h5 class="font-weight-semibold">Link de CallBack </h5>
    </b-col>

    <!-- Link -->
  <b-col md="8">
      <b-form-group>
        <label class="" >Link para aviso de pagamento</label>
        <feather-icon

            icon="AlertCircleIcon"
            size="10"
            class="text-info ml-1"
            badge-classes="badge-info"
          />
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-form-checkbox
              name="checkbox-input"
            />
          </b-input-group-prepend>
          <b-form-input 
           
           />
        </b-input-group>
      </b-form-group>
    </b-col>
    
    <b-col md="8" class="d-flex justify-content-center">
 

          <b-button variant="gradient-dark "
           v-if="!spiner"
            
             @click="SalvarEstabelecimento()"
            >
              Salvar
          </b-button>
       
          <b-button
          v-if="spiner"
              variant="gradient-dark"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              Salvando
          </b-button>
          
      

 </b-col>

  </b-row>
</template>
<script>
import { VBPopover, BButton, BPopover, BFormSelect, BInputGroup, BFormInput, BInputGroupPrepend, BRow, BCol, BFormCheckbox, BFormRadio, BFormGroup} from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
      BInputGroup, 
      BFormInput, 
      BInputGroupPrepend, 
      BRow, 
      BCol, 
      BFormCheckbox, 
      BFormRadio, 
      BFormGroup,
      BFormSelect,VBPopover, BButton, BPopover
  },
 
    data() {
        return {
            selected: null,
            spiner:false,
      options: [
        { value: 1, text: 1 },
        { value: 2, text: 2 },
        { value: 3, text: 3 },
        { value: 4, text: 4 },
        { value: 5, text: 5 },
      ],
      optionsPeriodo: [
        { value: 0, text: "Dispensar" },
        { value: 2, text: "Taxa mensal"}
      ],
        }
    },

    created() {
  
  },
  computed: {
    estabelecimento() {

       return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
    },
  },

  methods: {
  async  SalvarEstabelecimento(){
    this.isDisabled = true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false
         
        })
        .catch((error) => {
          this.isDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
    //   this.isDisabled = false;
      this.show = true;
    },
  },
};
</script>
    
<style lang="">
    
</style>